module.exports = __webpack_public_path__ + "static/media/schody13 - schody drewniane zabiegowe nakladane.8c87c37c.jpg";